import { motion } from "framer-motion";
import { ArrowRight, Phone } from "lucide-react";
import { IMAGES, CONTACT } from "@/data/site";

const go = (href) => document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });

export const Hero = () => {
  return (
    <section id="home" data-testid="hero-section" className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img src={IMAGES.hero} alt="Luxury car" className="w-full h-full object-cover scale-105" />
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/80 to-black/40" />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-black/60" />
        <div className="absolute inset-0 grain opacity-[0.06] pointer-events-none" />
      </div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-12 w-full pt-32 pb-20">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="max-w-3xl"
        >
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-12 bg-gold" />
            <span className="text-xs tracking-[0.3em] uppercase text-gold font-bold font-mono-x">Est. 2026 · Window Tinting & Auto Customs</span>
          </div>

          <h1 className="font-heading font-black uppercase leading-[0.9] tracking-tighter text-5xl sm:text-7xl lg:text-8xl">
            <span className="block text-white">Driven</span>
            <span className="block gold-gradient-text">By Detail</span>
          </h1>

          <p className="mt-8 text-base lg:text-lg text-neutral-300 max-w-xl leading-relaxed">
            Premium window tinting that transforms your ride — heat-rejecting, UV-blocking films
            installed with obsessive precision. AS Auto Works treats every vehicle like a flagship.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <button
              data-testid="hero-cta-button"
              onClick={() => go("#booking")}
              className="group inline-flex items-center justify-center gap-3 bg-gold text-black font-bold uppercase tracking-widest text-sm px-9 py-4 hover:bg-[#C5A028] transition-colors border border-[#D4AF37]"
            >
              Request a Quote
              <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
            </button>
            <a
              href={`tel:${CONTACT.phone.replace(/[^+\d]/g, "")}`}
              data-testid="hero-call-button"
              className="inline-flex items-center justify-center gap-3 bg-transparent text-white font-bold uppercase tracking-widest text-sm px-9 py-4 hover:bg-[#CC1100] hover:border-[#CC1100] transition-colors border border-white/25"
            >
              <Phone size={18} /> Call Us
            </a>
          </div>
        </motion.div>
      </div>

      <div className="absolute bottom-8 left-0 w-full">
        <div className="h-px w-full bg-gradient-to-r from-transparent via-[#CC1100]/60 to-transparent" />
      </div>
    </section>
  );
};
